import Marquee from "react-fast-marquee";

const ITEMS = [
  "What is true",
  "What does not add up",
  "Known better every month",
  "Cite or stay silent",
  "Nobody fixes the same thing twice",
];

export const Ticker = () => (
  <div data-testid="editorial-ticker" className="overflow-hidden border-y-2 border-black bg-black py-5 text-white">
    <Marquee speed={32} gradient={false} pauseOnHover>
      {ITEMS.map((item, i) => (
        <span key={i} className="mx-8 flex items-center gap-8 text-xl font-extrabold uppercase tracking-tight md:text-3xl">
          <span className="whitespace-nowrap">{item}</span>
          <span className="text-white/40">///</span>
        </span>
      ))}
    </Marquee>
  </div>
);
